const Duration = require('./duration');

module.exports = {Duration};
